import React from "react";
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class Logo extends React.PureComponent {
    render() {
        let { className, isWhite } = this.props;
        return (
            <NavLink
                to={'/'}
                className={className}>
                <img
                    className={'logo'}
                    src={isWhite ? require('../../assets/images/logo-white-2.png') : require('../../assets/images/logo.png')}
                    alt={'Soundslates'}
                />
            </NavLink>
        );
    }
}

Logo.propTypes = {
    isWhite: PropTypes.bool,
    className: PropTypes.string,
};
